import React from "react";

const AdminSidebar = ({ activePage, setActivePage, isOpen, setIsOpen, user }) => {
  const userName = user?.name || "Admin User";
  const userEmail = user?.email || "admin@sdtech.com";
  const userInitials = userName
    .split(" ")
    .map((n) => n[0])
    .join("")
    .substring(0, 2)
    .toUpperCase();
  const userRole = user?.role || "admin";
  const isAdmin = userRole === "admin" || userRole === "manager";

  // Admin/Manager ke liye full menu
  const adminMenu = [
    { id: "dashboard", icon: "📊", label: "Dashboard" },
    { id: "leads", icon: "🎯", label: "Leads" },
    { id: "calls", icon: "📞", label: "Call Logs" },
    { id: "bulk-upload", icon: "📤", label: "Bulk Upload" },
    { id: "tasks", icon: "✅", label: "Tasks" },
    { id: "team", icon: "👥", label: "Team" },
    { id: "accounting", icon: "💰", label: "Accounting" },
    { id: "reports", icon: "📈", label: "Reports" },
  ];

  // Employee ke liye limited menu
  const employeeMenu = [
    { id: "dashboard", icon: "📊", label: "My Dashboard" },
  ];

  const menuItems = isAdmin ? adminMenu : employeeMenu;

  return (
    <>
      {isOpen && (
        <div
          className="admin-sidebar-overlay active"
          onClick={() => setIsOpen(false)}
        />
      )}

      <aside className={`admin-sidebar ${isOpen ? "open" : ""}`}>
        {/* Logo */}
        <div className="admin-sidebar-logo">
          <div className="admin-sidebar-logo-inner">
            <div className="admin-sidebar-logo-icon">
              <span>SD</span>
            </div>
            <div className="admin-sidebar-logo-text">
              <h2>
                SD<span className="highlight">tech</span>
                {isAdmin ? "Admin" : "Portal"}
              </h2>
              <p>{isAdmin ? "Management Panel" : "Employee Panel"}</p>
            </div>
          </div>
        </div>

        {/* Role Badge */}
        <div
          style={{
            padding: "8px 16px",
            marginLeft: 16,
            marginRight: 16,
            marginTop: 16,
            marginBottom: 8,
            borderRadius: 8,
            backgroundColor: isAdmin ? "#eff6ff" : "#f0fdf4",
            border: `1px solid ${isAdmin ? "#bfdbfe" : "#bbf7d0"}`,
          }}
        >
          <span
            style={{
              fontSize: 11,
              fontWeight: 700,
              color: isAdmin ? "#1e40af" : "#166534",
              textTransform: "uppercase",
              letterSpacing: "0.05em",
            }}
          >
            {isAdmin ? "👑 " : "👤 "}
            {userRole}
          </span>
        </div>

        {/* Navigation */}
        <nav className="admin-sidebar-nav">
          <div className="nav-section-label">
            {isAdmin ? "Main Menu" : "My Workspace"}
          </div>

          {menuItems.map((item) => (
            <button
              key={item.id}
              className={`nav-item ${activePage === item.id ? "active" : ""}`}
              onClick={() => {
                setActivePage(item.id);
                setIsOpen(false);
              }}
            >
              <span className="nav-item-icon">{item.icon}</span>
              <span className="nav-item-label">{item.label}</span>
            </button>
          ))}
        </nav>

        {/* User Info */}
        <div className="admin-sidebar-user">
          <div className="admin-sidebar-user-inner">
            <div className="admin-avatar">
              <span>{userInitials}</span>
            </div>
            <div className="admin-sidebar-user-info">
              <div className="user-name">{userName}</div>
              <div className="user-email">{userEmail}</div>
            </div>
          </div>
        </div>
      </aside>
    </>
  );
};

export default AdminSidebar;